function facetsPriceRange() {
  const rangeInput = document.querySelectorAll('.js-price-range .range-input input');

  let priceGap = 1;

  rangeInput.forEach((input) => {
    input.addEventListener('input', (e) => {
      let minVal = parseInt(rangeInput[0].value),
        maxVal = parseInt(rangeInput[1].value);
      if (e.target.classList.contains('field__input-price-min')) {
        e.target.nextElementSibling.classList.remove('active');
        e.target.classList.add('active');
        e.target.closest('.js-price-range').querySelector('.range-slider-min .value').textContent = minVal;
      } else {
        e.target.previousElementSibling.classList.remove('active');
        e.target.classList.add('active');
        e.target.closest('.js-price-range').querySelector('.range-slider-max .value').textContent = maxVal;
      }
      if (maxVal - minVal < priceGap) {
        if (e.target.classList.contains('field__input-price-min')) {
          rangeInput[0].value = maxVal - priceGap;
        } else {
          rangeInput[1].value = minVal + priceGap;
        }
      }
    });
  });
}

facetsPriceRange();
